import React, { useState } from 'react';
import { Input, Button, Modal } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import MapPicker from './MapPicker';

const GeoLocationField = ({ value = '', onChange }) => {
  const [coordinates, setCoordinates] = useState(value);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOpenModal = () => {
    setIsModalVisible(true);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize')); // Force le redimensionnement
    }, 200);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    onChange(coordinates);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSelectCoordinates = (coords) => {
    const coordString = `${coords[0]}, ${coords[1]}`;
    setCoordinates(coordString);
  };

  return (
    <>
      <Input
        value={coordinates}
        readOnly
        suffix={<Button icon={<EnvironmentOutlined />} onClick={handleOpenModal} />}
        placeholder="Coordonnées géographiques"
      />
      <Modal
        title="Sélectionnez les coordonnées géographiques"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirmer"
        cancelText="Annuler"
        width={800}
        style={{ visibility: isModalVisible ? 'visible' : 'hidden' }} // Utilisation de visibility
      >
        <MapPicker onSelect={handleSelectCoordinates} isModalVisible={isModalVisible} />
      </Modal>
    </>
  );
};

export default GeoLocationField;
